import { useState } from "react";
import { Check, Trash2 } from "lucide-react";
import { toast } from "sonner";
import { api, errMsg } from "@/lib/api";
import { FormDialog } from "@/components/kids/kidsUi";

function Row({ base, t, onChanged }) {
  const [name, setName] = useState(t.name);
  const rename = () => api.put(`${base}/documents/tags/${t.id}`, { name }).then(() => { toast.success("Tag renamed"); onChanged(); }).catch((e) => toast.error(errMsg(e)));
  const del = () => api.delete(`${base}/documents/tags/${t.id}`).then(() => { toast.success("Tag deleted"); onChanged(); }).catch((e) => toast.error(errMsg(e)));
  return (
    <li className="flex items-center gap-2" data-testid={`tag-row-${t.id}`}>
      <input className="q-input min-h-[44px] min-w-0 flex-1" value={name} maxLength={30} onChange={(e) => setName(e.target.value)} data-testid={`tag-name-${t.id}`} />
      <button className="q-btn q-btn-ghost min-h-[44px] min-w-[44px]" aria-label="Save name" disabled={name === t.name} onClick={rename} data-testid={`tag-rename-${t.id}`}><Check className="h-4 w-4" /></button>
      <button className="q-btn q-btn-ghost min-h-[44px] min-w-[44px]" aria-label="Delete tag" onClick={del} data-testid={`tag-delete-${t.id}`}><Trash2 className="h-4 w-4" /></button>
    </li>
  );
}

export default function TagsDialog({ base, d, onClose, onChanged }) {
  const [name, setName] = useState("");
  const add = () => api.post(`${base}/documents/tags`, { name }).then(() => { setName(""); onChanged(); }).catch((e) => toast.error(errMsg(e)));
  return (
    <FormDialog open onClose={onClose} title="Family tags" description="Everyone with Documents sees these tags. Up to 50." testid="tags-dialog">
      <ul className="mb-4 space-y-2">{d.tags.map((t) => <Row key={`${t.id}-${t.name}`} base={base} t={t} onChanged={onChanged} />)}</ul>
      <div className="flex gap-2">
        <input className="q-input min-h-[44px] min-w-0 flex-1" placeholder="New tag" value={name} maxLength={30} onChange={(e) => setName(e.target.value)} data-testid="tag-new-input" />
        <button className="q-btn q-btn-primary min-h-[44px]" disabled={!name.trim()} onClick={add} data-testid="tag-add-btn">Add</button>
      </div>
    </FormDialog>
  );
}
